export default __webpack_public_path__ + "static/media/vhdl-icon.e0e58cf9.svg";